import { ProductType } from 'cart-model';
import { EventType } from 'common-event';
import { useRouter } from 'common-react';
import { Fund } from 'funds-model';
import _ from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logAddToCart, logFundEvent, logRemoveFromCart } from '../../../model/events';
import { urlToDataWizard } from '../../../model/integration';
import ProductWizardState from '../../../model/ProductWizardState';
import { productWizardActions } from '../../../model/store';
import Screen from '../../ProductWizard/Screen';

export const useAddCartAction = (
    source: Screen,
    isTransfer?: boolean) => {
  const [url] = useTranslation('url');
  const dispatch = useDispatch();
  const { history } = useRouter();
  const cartFunds = useSelector((state: ProductWizardState) => state.cartState.cartFunds);
  const productType = useSelector((state: ProductWizardState) => state.uiState.productType)!;

  const cartFundsRef = useRef(cartFunds);
  const productTypeRef = useRef(productType);

  useEffect(() => {
    cartFundsRef.current = cartFunds;
    productTypeRef.current = productType;
  }, [cartFunds, productType]);

  const addToCart = useCallback((fund: Fund) => {
    const currentCartFunds = cartFundsRef.current;
    const currentProductType = productTypeRef.current;
    const isChosen = _.some(currentCartFunds, f => f.fund.id === fund.id && f.productType === productType);

    if (isTransfer) {
      dispatch(productWizardActions.addTransferCartFund({ fund, productType: currentProductType, screenCode: source.code }));
      logFundEvent(EventType.productAddToCart, source, fund, productType);
      logAddToCart(fund, currentProductType, source);

      if (currentProductType === ProductType.ikze) {
        history.push(`/${url('product-wizard')}/${url('transfer-ikze-entrepreneur')}`);
      } else {
        window.location.href = urlToDataWizard();
      }
      return;
    }

    if (isChosen) {
      dispatch(productWizardActions.removeCartFund({ fund, productType: currentProductType }));
      logFundEvent(EventType.productRemove, source, fund, currentProductType);
      logRemoveFromCart(fund, currentProductType, source);
    } else {
      dispatch(productWizardActions.addCartFund({ fund, productType: currentProductType, screenCode: source.code }));
      logFundEvent(EventType.productAddToCart, source, fund, currentProductType);
      logAddToCart(fund, currentProductType, source);
    }
  }, [isTransfer, source, dispatch, history, url]);

  return addToCart;
}